import React, { memo } from 'react';
import styles from './ViewTower.module.scss';
import noBattleCardIcon from '../../assets/icons/icon-no-battle-card.png';
import { Button } from 'react-bootstrap';
import IconOpenSeaWhite from '../../assets/icons/icon_opensea_white.png';
import IconBinanceWhite from '../../assets/icons/icon_binance_white.png';

const NoBattleCardsOwnedNotice = memo(({ battleCardsCount, userTicketCount }) => {
    const equivalentCards = battleCardsCount + userTicketCount;
    return (
        <>
            {equivalentCards === 0 ?
                (
                    <div className={styles.battle_card_notice_section}>
                        <div className={styles.battle_card_notice_items}>
                            <div className={styles.no_battle_card_image}>
                                <img src={noBattleCardIcon} alt="battle-card-cross" />
                            </div>
                            <div className={styles.no_battle_card_description}>
                                <span>You are <b>NOT</b> able to claim any TOWER token unless you hold at least <b>ONE</b> <u>TOWER Battle Card</u> or <u>TOWER Ticket</u>.</span>
                            </div>
                        </div>

                        <div className={styles.button_wrapper}>
                            <Button variant="primary" className={styles.buy_card_btn} href={'https://opensea.io/collection/tower-battle-cards'} target={"_blank"} rel="noopener noreferrer">
                                <img className={styles.opensea_icon} src={IconOpenSeaWhite} alt="opensea" />
                                <span>{'Buy Cards'}</span>
                            </Button>

                            <Button variant="primary" className={styles.buy_card_btn} href={'https://www.binance.com/en/nft/profile/animoca-brands-ad3bcf389e3eb2213724659b99b94cd0?category=created'} target={"_blank"} rel="noopener noreferrer">
                                <img className={styles.binance_icon} src={IconBinanceWhite} alt="binance" />
                                <span>{'Buy Tickets'}</span>
                            </Button>
                        </div>
                    </div>
                ) : <></>
            }
        </>
    );
});

export { NoBattleCardsOwnedNotice };